import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack} from '@mui/material';
import {Close} from '@icons/index';

interface AlertComponentProps {
  actions?: JSX.Element | JSX.Element[];
  description?: string;
  handleClose: () => void;
  title?: string;
  'aria-label'?: string;
}

const AlertComponent = (props: AlertComponentProps) => {
  const {
    actions,
    description,
    handleClose,
    title,
    'aria-label': ariaLabel
  } = props;

  return (
    <Dialog open={true} maxWidth="md" fullWidth onClose={handleClose} aria-label={ariaLabel}>
      <DialogTitle>
        {title}
        <IconButton aria-label="close" onClick={handleClose}>
          <Close/>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack pt="60px" pb={actions ? '20px' : '60px'}>
          {description}
        </Stack>
      </DialogContent>
      {!!actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default AlertComponent;
